<template>
  <section class="content">
    <div class="box box-primary">
      <div class="box-header with-border">
        <h3 class="box-title" id="title">{{'orders' | translate}}</h3>
        <br>
        <small class="text-bold">
          {{pagination.from}} - {{pagination.to}} von {{pagination.total}} {{'orders' | translate}} {{'filter_text' | translate}}
        </small>
      </div>
      <div class="box-controls">
        <div class="btn-group">
          <button
            type="button"
            data-toggle="collapse"
            data-target="#coll1"
            aria-expanded="true"
            aria-controls="coll1"
            class="btn btn-default btn-sm"
            >
            <i class="fa fa-sort mr-5"></i>{{'show_hide_filters' | translate}}
          </button>
        </div>
        <my-pagination :total="pagination.total" :per-page="pagination.per_page" :pagination="pagination"></my-pagination>
        <div class="row">
          <div class="col-xs-12">
            <div class="margin"></div>
            <div id="coll2" class="collapse in" aria-expanded="true" style="">
              <table class="table no-margin">
                <tbody>
                <tr>
                  <td style="width:auto">1.</td>
                  <td style="width:auto">{{'open-orders' | translate}}</td>
                  <td style="width:70%">
                    <div class="progress progress-sm">
                      <div
                        v-if="open + initials !== 0"
                        class="progress-bar progress-bar-info"
                        :style="'width: ' +  open * 100/(open + initials) + '%'"
                      >
                      </div>
                      <div v-else class="progress-bar progress-bar-info" style="width: 0%"></div>
                    </div>
                  </td>
                  <td><span class="badge bg-info">{{open}}</span></td>
                </tr>
                <tr>
                  <td>2.</td>
                  <td>{{'reserved_orders' | translate}}</td>
                  <td>
                    <div class="progress progress-sm">
                      <div
                        v-if="open + initials !== 0"
                        class="progress-bar progress-bar-primary"
                        :style="'width: ' +  initials * 100/(open + initials) + '%'"
                      >
                      </div>
                      <div class="progress-bar progress-bar-primary" style="width: 0%"></div>
                    </div>
                  </td>
                  <td><span class="badge bg-primary">{{initials}}</span></td>
                </tr>
                </tbody>
              </table>
            </div>
            <div class="collapse in" id="coll1">
              <div class="pt-10 row">
                <div class="col-md-3 col-sm-6">
                  <div class="input-group">
                    <div class="input-group-addon">
                      {{'status' | translate}}
                    </div>
                    <select class="form-control" v-model="selectedSplitStatus" @change.prevent="paginate('status')">
                      <optgroup
                        v-for="(group, name) in $store.getters.orderStatusFilters"
                        class="normal"
                        :label="`${name}_filter` | translate"
                      >
                        <option class="normal" v-for="option in group" :value="`${name}-${option}`">
                          {{`${name}_${option}_filter` | translate}}
                        </option>
                      </optgroup>
                    </select>
                  </div>
                </div>
                <div class="col-md-3 col-sm-6">
                  <div class="input-group">
                    <div class="input-group-addon">
                      {{'sales_channel' | translate}}
                    </div>
                    <select class="form-control" v-model="selectedChannel" @change.prevent="paginate('channel')">
                      <template v-for="option in $store.getters.orderChannelsFilters">
                        <option :value="option" class="normal">{{option | translate}}</option>
                      </template>
                    </select>
                  </div>
                </div>
                <div class="col-md-3 col-sm-6">
                  <div class="input-group">
                    <div class="input-group-addon">
                      {{'payment_method' | translate}}
                    </div>
                    <select
                      class="form-control"
                      v-model="selectedPaymentMethod"
                      @change.prevent="paginate('paymentMethod')"
                    >
                      <template v-for="option in $store.getters.orderPaymentsFilters">
                        <option :value="option" class="normal">{{option | translate}}</option>
                      </template>
                    </select>
                  </div>
                </div>
                <div class="col-md-3 col-sm-6">
                  <div class="input-group">
                    <div class="input-group-addon">
                      {{'period' | translate}}
                    </div>
                    <date-range-picker
                      :startDate="startRange"
                      :endDate="endRange"
                      id="ordertime"
                      @pepe="onDateRangeChanged"
                    >
                    </date-range-picker>
                  </div>
                </div>
              </div>
              <div class="pt-10 row">
                <div class="col-md-3 col-sm-6">
                  <div class="input-group">
                    <input
                      type="text"
                      name="search"
                      :disabled="loading"
                      v-model="selectedClientNr"
                      class="form-control"
                      :placeholder="'client_nr' | translate"
                      @keyup.13.prevent="paginate('','')"
                      @blur="paginate('','')"
                    >
                    <div class="input-group-btn">
                      <button type="submit" name="submit" class="btn">
                        <i :class="['fa', loading ? 'fa-spinner fa-spin' : 'fa-search']"></i>
                      </button>
                    </div>
                  </div>
                </div>
                <div class="col-md-3 col-sm-6">
                  <div class="input-group">
                    <input
                      type="text"
                      name="search"
                      :disabled="loading"
                      v-model="selectedEmail"
                      class="form-control"
                      :placeholder="'customer_email' | translate"
                      @keyup.13.prevent="paginate('','')"
                      @blur="paginate('','')"
                    >
                    <div class="input-group-btn">
                      <button type="submit" name="submit" class="btn">
                        <i :class="['fa', loading ? 'fa-spinner fa-spin' : 'fa-search']"></i>
                      </button>
                    </div>
                  </div>
                </div>
                <div class="col-md-3 col-sm-6">
                  <div class="input-group">
                    <input
                      type="text" name="search"
                      v-model="selectedZip"
                      class="form-control"
                      :placeholder="'zip_code' | translate"
                      @keyup.13.prevent="paginate('','')"
                      @blur="paginate('','')"
                    >
                    <div class="input-group-btn">
                      <button type="submit" name="submit" class="btn">
                        <i :class="['fa', loading ? 'fa-spinner fa-spin' : 'fa-search']"></i>
                      </button>
                    </div>
                  </div>
                </div>
                <div class="col-md-3 col-sm-6">
                  <div class="input-group">
                    <input
                      type="text"
                      name="search"
                      :disabled="loading"
                      v-model="selectedCity"
                      class="form-control"
                      :placeholder="'customer_city' | translate"
                      @keyup.13.prevent="paginate('','')"
                      @blur="paginate('','')"
                    >
                    <div class="input-group-btn">
                      <button type="submit" name="submit" class="btn">
                        <i :class="['fa', loading ? 'fa-spinner fa-spin' : 'fa-search']"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="pt-10 row">
                <div class="col-md-3 col-sm-6">
                  <div class="input-group">
                    <input
                      type="text"
                      name="search"
                      :disabled="loading"
                      v-model="selectedCustomerFirstName"
                      class="form-control"
                      :placeholder="'client_first_name' | translate"
                      @keyup.13.prevent="paginate('','')"
                      @blur="paginate('','')"
                    >
                    <div class="input-group-btn">
                      <button type="submit" name="submit" class="btn">
                        <i :class="['fa', loading ? 'fa-spinner fa-spin' : 'fa-search']"></i>
                      </button>
                    </div>
                  </div>
                </div>
                <div class="col-md-3 col-sm-6">
                  <div class="input-group">
                    <input
                      type="text"
                      name="search"
                      :disabled="loading"
                      v-model="selectedClientName"
                      class="form-control"
                      :placeholder="'client_last_name' | translate"
                      @keyup.13.prevent="paginate('','')"
                      @blur="paginate('','')"
                    >
                    <div class="input-group-btn">
                      <button type="submit" name="submit" class="btn">
                        <i :class="['fa', loading ? 'fa-spinner fa-spin' : 'fa-search']"></i>
                      </button>
                    </div>
                  </div>
                </div>
                <div class="col-md-3 col-sm-6">
                  <div class="input-group">
                    <input
                      type="text"
                      name="search"
                      :disabled="loading"
                      v-model="selectedBillingFirstName"
                      class="form-control"
                      :placeholder="'billing_first_name' | translate"
                      @keyup.13.prevent="paginate('','')"
                      @blur="paginate('','')"
                    >
                    <div class="input-group-btn">
                      <button type="submit" name="submit" class="btn">
                        <i :class="['fa', loading ? 'fa-spinner fa-spin' : 'fa-search']"></i>
                      </button>
                    </div>
                  </div>
                </div>
                <div class="col-md-3 col-sm-6">
                  <div class="input-group">
                    <input
                      type="text"
                      name="search"
                      :disabled="loading"
                      v-model="selectedBillingLastName"
                      class="form-control"
                      :placeholder="'billing_last_name' | translate"
                      @keyup.13.prevent="paginate('','')"
                      @blur="paginate('','')"
                    >
                    <div class="input-group-btn">
                      <button type="submit" name="submit" class="btn">
                        <i :class="['fa', loading ? 'fa-spinner fa-spin' : 'fa-search']"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="pt-10 row">
                <div class="col-md-3 col-sm-6">
                  <div class="input-group">
                    <input
                      type="text"
                      name="search"
                      :disabled="loading"
                      v-model="selectedSku"
                      class="form-control"
                      :placeholder="'ordernumber' | translate"
                      @keyup.13.prevent="paginate('','')"
                      @blur="paginate('','')"
                    >
                    <div class="input-group-btn">
                      <button type="submit" name="submit" class="btn">
                        <i :class="['fa', loading ? 'fa-spinner fa-spin' : 'fa-search']"></i>
                      </button>
                    </div>
                  </div>
                </div>
                <div class="col-md-3 col-sm-6">
                  <div class="input-group">
                    <input
                      type="text"
                      name="search"
                      :disabled="loading"
                      v-model="selectedQBID"
                      class="form-control"
                      placeholder="QB ID"
                      @keyup.13.prevent="paginate('','')"
                      @blur="paginate('','')"
                    >
                    <div class="input-group-btn">
                      <button type="submit" name="submit" class="btn">
                        <i :class="['fa', loading ? 'fa-spinner fa-spin' : 'fa-search']"></i>
                      </button>
                    </div>
                  </div>
                </div>
                <div class="col-md-3 col-sm-6">
                  <div class="input-group">
                    <input
                      type="text"
                      name="search"
                      :disabled="loading"
                      v-model="selectedMerchant"
                      class="form-control"
                      :placeholder="'merchant_name' | translate"
                      @keyup.13.prevent="paginate('','')"
                      @blur="paginate('','')"
                    >
                    <div class="input-group-btn">
                      <button type="submit" name="submit" class="btn">
                        <i :class="['fa', loading ? 'fa-spinner fa-spin' : 'fa-search']"></i>
                      </button>
                    </div>
                  </div>
                </div>
                <div class="col-md-3 col-sm-6">
                  <div class="input-group">
                    <input
                      type="text"
                      name="search"
                      :disabled="loading"
                      v-model="selectedImageId"
                      class="form-control"
                      :placeholder="'image_id' | translate"
                      @keyup.13.prevent="paginate('','')"
                      @blur="paginate('','')"
                    >
                    <div class="input-group-btn">
                      <button type="submit" name="submit" class="btn">
                        <i :class="['fa', loading ? 'fa-spinner fa-spin' : 'fa-search']"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="pt-10 row">
                <div class="col-md-3 col-sm-6">
                  <div class="input-group">
                    <input
                      type="text"
                      name="search"
                      :disabled="loading"
                      v-model="selectedGtin"
                      class="form-control"
                      placeholder="GTIN"
                      @keyup.13.prevent="paginate('','')"
                      @blur="paginate('','')"
                    >
                    <div class="input-group-btn">
                      <button type="submit" name="submit" class="btn">
                        <i :class="['fa', loading ? 'fa-spinner fa-spin' : 'fa-search']"></i>
                      </button>
                    </div>
                  </div>
                </div>
                <div class="col-md-3 col-sm-6">
                  <div class="input-group">
                    <input
                      type="text"
                      name="search"
                      :disabled="loading"
                      v-model="mirapodoOrderNr"
                      class="form-control"
                      :placeholder="`MP ID Addition`"
                      @keyup.13.prevent="paginate('','')"
                      @blur="paginate('','')"
                    >
                    <div class="input-group-btn">
                      <button type="submit" name="submit" class="btn">
                        <i :class="['fa', loading ? 'fa-spinner fa-spin' : 'fa-search']"></i>
                      </button>
                    </div>
                  </div>
                </div>
                <div class="col-md-3 col-sm-6">
                  <div class="input-group">
                    <div class="input-group-addon">
                      {{'country' | translate}}
                    </div>
                    <select class="form-control" v-model="selectedCountry" @change.prevent="paginate('country')">
                      <template v-for="country in sortCountries">
                        <option :value="country" class="normal">{{country | newCountry($store.getters.language)}}</option>
                      </template>
                    </select>
                  </div>
                </div>
                <div class="col-md-3 col-sm-6 pull-right">
                  <b-btn @click="clearAll" class="btn btn-md btn-warning">
                    <i class="fa fa-undo mr-5"></i>{{'clear_filter' | translate}}
                  </b-btn>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="box-body">
        <template v-if="loading">
            <div class="row">
              <div class="col-xs-12 text-center">
                <img class="loading-gif" src="/static/img/blabla.svg"/>
              </div>
            </div>
        </template>
        <template v-else>
          <orders-table :orders="pagination.data" @correct="pepe($event)" @sort="sort($event)"></orders-table>
        </template>
      </div>
      <div class="box-footer">
        <my-pagination :total="pagination.total" :per-page="pagination.per_page" :pagination="pagination"></my-pagination>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  data () {
    return {
      loading: true,
      selectedSplitStatus: window.localStorage.getItem('splitStatus') ? window.localStorage.getItem('splitStatus') : 'all-all',
      selectedStatus: window.localStorage.getItem('orderStatus') ? window.localStorage.getItem('orderStatus') : 'all',
      selectedPaymentMethod: window.localStorage.getItem('paymentMethod') ? window.localStorage.getItem('paymentMethod') : 'all',
      selectedMerchant: window.localStorage.getItem('orderMerchant') ? window.localStorage.getItem('orderMerchant') : '',
      selectedChannel: parseInt(window.localStorage.getItem('orderChannel')) === 0 ? 'all' : window.localStorage.getItem('orderChannel'),
      selectedSku: window.localStorage.getItem('orderSku') ? window.localStorage.getItem('orderSku') : '',
      selectedQBID: window.localStorage.getItem('orderQBID') ? window.localStorage.getItem('orderQBID') : '',
      selectedClientNr: window.localStorage.getItem('orderClientNr') ? window.localStorage.getItem('orderClientNr') : '',
      selectedClientName: window.localStorage.getItem('orderClientName') ? window.localStorage.getItem('orderClientName') : '',
      selectedCustomerFirstName: window.localStorage.getItem('customerFirstName') ? window.localStorage.getItem('customerFirstName') : '',
      selectedBillingFirstName: window.localStorage.getItem('billingFirstName') ? window.localStorage.getItem('orderClientName') : '',
      selectedBillingLastName: window.localStorage.getItem('billingLastName') ? window.localStorage.getItem('billingLastName') : '',
      selectedStart: window.localStorage.getItem('selectedStart') ? window.localStorage.getItem('selectedStart') : '',
      selectedEnd: window.localStorage.getItem('selectedEnd') ? window.localStorage.getItem('selectedEnd') : '',
      selectedCity: window.localStorage.getItem('selectedCity') ? window.localStorage.getItem('selectedCity') : '',
      selectedZip: window.localStorage.getItem('selectedZip') ? window.localStorage.getItem('selectedZip') : '',
      selectedEmail: window.localStorage.getItem('selectedEmail') ? window.localStorage.getItem('selectedEmail') : '',
      selectedImageId: window.localStorage.getItem('selectedImageId') ? window.localStorage.getItem('selectedImageId') : '',
      selectedGtin: window.localStorage.getItem('selectedGtin') ? window.localStorage.getItem('selectedGtin') : '',
      mirapodoOrderNr: window.localStorage.getItem('mirapodoOrderNr') ? window.localStorage.getItem('mirapodoOrderNr') : '',
      sortType: window.localStorage.getItem('sortType') ? window.localStorage.getItem('sortType') : 'desc',
      selectedCountry: window.localStorage.getItem('selectedCountry') ? window.localStorage.getItem('selectedCountry') : '',
      dateRange: 'ciao',
      startRange: window.localStorage.getItem('selectedStart') ? moment(window.localStorage.getItem('selectedStart')) : moment().subtract(1, 'month'),
      endRange: window.localStorage.getItem('selectedEnd') ? moment(window.localStorage.getItem('selectedEnd')) : moment(),
      products: {},
      channel: 0,
      returns: 0,
      initials: 0,
      open: 0,
      mpCancel: 0,
      customerCancel: 0,
      newItems: 0,
      canceled: 0,
      shipped: 0,
      alerts: [],
      statuses: [],
      editAddress: {},
      isActive: '',
      sellOnline: '',
      pagination: {
        total: 0,
        per_page: 25,
        current_page: 1,
        total_pages: 0
      },
      backup: [],
      paginate (type, value) {
        this.loading = true
        let url = '?preflight=kek'
        if (type === 'page') {
          url += '&page='
          if (value === 'previous') {
            url += (this.pagination.current_page - 1)
          }
          if (value === 'next') {
            url += this.pagination.current_page >= this.pagination.last_page ? this.pagination.last_page : (this.pagination.current_page + 1)
          } else if (value !== 'next' && value !== 'previous') {
            url += value
          }
        }

        let statusValues = this.selectedSplitStatus.split('-')

        url += `&sort=${this.sortType}`
        url += `&ext_order_id=${this.selectedSku}`
        url += `&start=${this.selectedStart}&end=${this.selectedEnd}`
        url += `&sales_channel=${this.selectedChannel === 'all' ? '' : this.selectedChannel}`
        url += `&order_status=${statusValues[0] === 'all' ? '' : statusValues[0]}`
        url += `&payment_method=${this.selectedPaymentMethod === 'all' ? '' : this.selectedPaymentMethod}`
        url += `&line_status=${statusValues[1] === 'all' ? '' : statusValues[1]}`
        url += `&merchant=${this.selectedMerchant}`
        url += `&customer_id=${this.selectedClientNr}`
        url += `&customer_name=${this.selectedClientName}`
        url += `&order_id=${this.selectedQBID}`
        url += `&customer_email=${this.selectedEmail}`
        url += `&customer_zip_code=${this.selectedZip}`
        url += `&customer_city=${this.selectedCity}`
        url += `&customer_first_name=${this.selectedCustomerFirstName}`
        url += `&billing_first_name=${this.selectedBillingFirstName}`
        url += `&billing_last_name=${this.selectedBillingLastName}`
        url += `&imageId=${this.selectedImageId}`
        url += `&gtin=${this.selectedGtin}`
        url += `&ext_order_id_addition=${this.mirapodoOrderNr}`
        url += `&delivery_country=${this.selectedCountry === 'all' ? '' : this.selectedCountry}`

        window.localStorage.setItem('orderChannel', this.selectedChannel)
        window.localStorage.setItem('paymentMethod', this.selectedPaymentMethod)
        window.localStorage.setItem('orderStatus', this.selectedStatus)
        window.localStorage.setItem('sortType', this.sortType)
        window.localStorage.setItem('orderSplitStatus', this.selectedSplitStatus)
        window.localStorage.setItem('orderSku', this.selectedSku)
        window.localStorage.setItem('orderMerchant', this.selectedMerchant)
        window.localStorage.setItem('orderQBID', this.selectedQBID)
        window.localStorage.setItem('orderClientNr', this.selectedClientNr)
        window.localStorage.setItem('orderClientName', this.selectedClientName)
        window.localStorage.setItem('selectedEnd', this.selectedEnd)
        window.localStorage.setItem('selectedStart', this.selectedStart)
        window.localStorage.setItem('selectedCity', this.selectedCity)
        window.localStorage.setItem('selectedZip', this.selectedZip)
        window.localStorage.setItem('selectedEmail', this.selectedEmail)
        window.localStorage.setItem('selectedImageId', this.selectedImageId)
        window.localStorage.setItem('customerFirstName', this.selectedCustomerFirstName)
        window.localStorage.setItem('billingFirstName', this.selectedBillingFirstName)
        window.localStorage.setItem('billingLastName', this.selectedBillingLastName)
        window.localStorage.setItem('splitStatus', this.selectedSplitStatus)
        window.localStorage.setItem('selectedGtin', this.selectedGtin)
        window.localStorage.setItem('mirapodoOrderNr', this.mirapodoOrderNr)
        window.localStorage.setItem('selectedCountry', this.selectedCountry)

        API.get(`orders${url}`)
         .then(response => {
            this.pagination = response.data
            window.localStorage.setItem('orderPage', this.pagination.current_page)
            this.filterStatus()
            this.loading = false
          }).catch(error => {
            this.$store.dispatch('checkError', error)
         })
      }
    }
  },
  computed: {
    sortCountries () {
      if (this.$store.getters.orderCountries.find(x => x === 'de')) {
        return this.$store.getters.orderCountries.filter(x => x !== 'deutschland')
      }
      if (this.$store.getters.orderCountries.find(x => x === 'deutschland'))
      {
        return this.$store.getters.orderCountries.filter(x => x !== 'de')
      }
      return this.$store.getters.orderCountries
    }
  },
  methods: {
    filterOrders (event) {
      let orders = this.backup
      let status = ''
      this.pagination.data = []
      switch (event) {
        case 1:
          status = 'processing'
          break
        case 2:
          status = 'shipped'
          break
        case 3:
          status = 'returned'
          break
        case 4:
          status = 'canceled'
          break
        default:
          this.pagination.data = this.backup
          break
      }
      for (let x in orders) {
        for (let y in orders[x].status) {
          if (orders[x].status[y].label === status && status !== '') {
            this.pagination.data.push(orders[x])
          }
        }
      }
    },
    triggerStatus (status) {
      this.selectedStatus = status
      this.paginate('status')
    },
    onDateRangeChanged (picker) {
      this.dateRange = picker.startDate + ' - ' + picker.endDate
      this.startRange = picker.startDate
      this.endRange = picker.endDate
      this.selectedEnd = this.endRange.format('YYYY-MM-DD')
      this.selectedStart = this.startRange.format('YYYY-MM-DD')
      this.paginate('', '')
    },
    getStatus (status, order) {
      if (order === 'mp_cancellation') {
        return {label: 'mp_cancellation_status', style: 'text-danger', icon: 'fa fa-exclamation-triangle mr-5'}
      } else {
        if (status === 'cancelled') {
          return {label: 'cancelled', style: 'text-danger', icon: 'fa fa-ban mr-5'}
        }
        if (order === 'reserved') {
          return {label: 'reserved', style: 'text-primary', icon: 'fa fa-bookmark mr-5'}
        } else {
          if (status === 'returned') {
            return {label: 'returned_status', style: 'text-warning', icon: 'fa fa-reply mr-5'}
          }
          if (status  === 'open') {
            return {label: 'open', style: 'text-info', icon: 'fa fa-sign-in mr-5'}
          }
          if (status  === 'initial') {
            return {label: 'open', style: 'text-info', icon: 'fa fa-sign-in mr-5'}
          }
          if (status  === 'shipped') {
            return {label: 'fulfilled', style: 'text-success', icon: 'fa fa-sign-in mr-5'}
          }
          if (status  === 'fulfilled') {
            return {label: 'fulfilled', style: 'text-success', icon: 'fa fa-sign-in mr-5'}
          }
        }
      }
    },
    sort (value) {
      this.sortType = value
      this.paginate('', '')
    },
    getOrderStatus (status) {
      let statuses = []
      if (status === 'mp_cancellation') {
        statuses.push({label: 'mp_cancellation_status', style: 'label label-danger', icon: 'fa fa-exclamation-triangle'})
      } else {
        if (status === 'cancelled') {
          statuses.push({label: 'cancelled', style: 'label label-danger', icon: 'fa fa-ban'})
        }
        if (status === 'reserved') {
          statuses.push({label: 'reserved', style: 'label label-primary', icon: 'fa fa-bookmark'})
        } else {
          if (status === 'returned') {
            statuses.push({label: 'returned_status', style: 'label label-warning', icon: 'fa fa-reply'})
          }
          if (status === 'fulfilled') {
            statuses.push({label: 'fulfilled', style: 'label label-success', icon: 'fa fa-check'})
          }
          if (status === 'open') {
            statuses.push({label: 'order_status_open', style: 'label label-info', icon: 'fa fa-sign-in'})
          }
        }
      }
      return statuses
    },
    filterStatus () {
      let orders = this.pagination.data
      let back = []
      for (let x in orders) {
        back = this.getOrderStatus(orders[x].status)
        for (let lineStatus in orders[x].lines) {
         orders[x].lines[lineStatus].status = this.getStatus(orders[x].lines[lineStatus].status, orders[x].status)
        }
        for (let y in orders[x].merchants) {
          orders[x].merchants[y].status = this.getStatus(orders[x].merchants[y].status, orders[x].status)
        }
        orders[x].status = back
      }
    },
    pepe (event) {
      this.editOrderId = event
      API.get('orders/' + event + '/user')
        .then(response => {
          this.editAddress = response.data
          $('#openModal').click()
        })
    },
    alert (value) {
        let alert
        if (value.status === 200 || value.status === 204) {
          alert = {dismiss: 4, type: 'success', message: 'Update Successful', icon: 'icon fa fa-check', show: true}
        } else if (value.status === 0) {
          alert = {dismiss: 4, type: 'warning', message: 'Not modified. Company Already Exists', icon: 'icon fa fa-warning', show: true}
        } else {
          alert = {dismiss: 4, type: 'danger', message: `There was an error: ${value.body.message}`, icon: 'icon fa fa-ban', show: true}
        }
        //this.alerts.push(alert)
        this.$store.commit('pushAlert', alert)
      },
    clearAll () {
      this.selectedSplitStatus = 'all-all'
      this.selectedStatus = 'all'
      this.selectedPaymentMethod = 'all'
      this.selectedMerchant = ''
      this.selectedChannel = 'all'
      this.selectedSku = ''
      this.selectedQBID = ''
      this.selectedClientNr = ''
      this.selectedClientName = ''
      this.selectedCustomerFirstName = ''
      this.selectedBillingFirstName = ''
      this.selectedBillingLastName = ''
      this.selectedStart = ''
      this.selectedEnd = ''
      this.selectedCity = ''
      this.selectedZip = ''
      this.selectedEmail = ''
      this.selectedGtin = ''
      this.mirapodoOrderNr = ''
      this.selectedCountry = ''
      this.selectedImageId = ''
      this.sortType = 'desc'
      this.startRange = moment().subtract(1, 'month')
      this.endRange = moment()

      window.localStorage.setItem('orderChannel', this.selectedChannel)
      window.localStorage.setItem('paymentMethod', this.selectedPaymentMethod)
      window.localStorage.setItem('orderStatus', this.selectedStatus)
      window.localStorage.setItem('orderSplitStatus', this.selectedSplitStatus)
      window.localStorage.setItem('orderSku', this.selectedSku)
      window.localStorage.setItem('orderMerchant', this.selectedMerchant)
      window.localStorage.setItem('orderQBID', this.selectedQBID)
      window.localStorage.setItem('orderClientNr', this.selectedClientNr)
      window.localStorage.setItem('orderClientName', this.selectedClientName)
      window.localStorage.setItem('selectedEnd', this.selectedEnd)
      window.localStorage.setItem('selectedStart', this.selectedStart)
      window.localStorage.setItem('selectedCity', this.selectedCity)
      window.localStorage.setItem('selectedZip', this.selectedZip)
      window.localStorage.setItem('selectedEmail', this.selectedEmail)
      window.localStorage.setItem('customerFirstName', this.selectedCustomerFirstName)
      window.localStorage.setItem('billingFirstName', this.selectedBillingFirstName)
      window.localStorage.setItem('billingLastName', this.selectedBillingLastName)
      window.localStorage.setItem('selectedGtin', this.selectedGtin)
      window.localStorage.setItem('selectedImageId', this.selectedImageId)
      window.localStorage.setItem('mirapodoOrderNr', this.mirapodoOrderNr)
      window.localStorage.setItem('selectedCountry', this.selectedCountry)

      this.paginate()
    }
  },
  mounted () {
    this.$nextTick(() => {
      let statusValues = this.selectedSplitStatus.split('-')
      let url = '?page=' + window.localStorage.getItem('orderPage')
      url += `&sort=${this.sortType}`
      url += `&ext_order_id=${this.selectedSku}`
      url += `&sales_channel=${this.selectedChannel === 'all' ? '' : this.selectedChannel}`
      url += `&order_status=${statusValues[0] === 'all' ? '' : statusValues[0]}`
      url += `&payment_method=${this.selectedPaymentMethod === 'all' ? '' : this.selectedPaymentMethod}`
      url += `&line_status=${statusValues[1] === 'all' ? '' : statusValues[1]}`
      url += `&merchant=${this.selectedMerchant}`
      url += `&customer_id=${this.selectedClientNr}`
      url += `&customer_name=${this.selectedClientName}`
      url += `&order_id=${this.selectedQBID}`
      url += `&start=${this.selectedStart}&end=${this.selectedEnd}`
      url += `&imageId=${this.selectedImageId}`
      url += `&gtin=${this.selectedGtin}`
      url += `&ext_order_id_addition=${this.mirapodoOrderNr}`
      API.get(`orders${url}`)
        .then(response => {
          this.pagination = response.data
          this.backup = response.data.data
          this.filterStatus()
          this.loading = false
        })
        .catch(error => {
          if (this.$store.dispatch('checkError', error)) {
            this.$store.commit('pushAlert', {dismiss: 4, type: 'danger', message: `There was an error: ${value.body.message}`, icon: 'icon fa fa-ban', show: true})
          }
        })
      API.get('orders/stats')
        .then(response => {
            this.open = response.data.open
            this.returns = response.data.return
            this.newItems = response.data.new
            this.shipped = response.data.shipped
            this.canceled = response.data.canceled
            this.initials = response.data.reserved
            this.mpCancel = response.data.mp_cancellation
          })
      })
    }
  }
</script>
<style>
  select option.normal{margin:40px;color:#fff;text-shadow:0 1px 0 rgba(0,0,0,.4)}select option.normal{background:#202227}
</style>
<style scoped>
  .loading-gif {
    padding-top: 8px;
    padding-bottom: 15px;
    width: 15%;
  }
  optgroup.normal {
    background:#202227;
    color:#fff;
  }
</style>



// WEBPACK FOOTER //
// src/components/views/Orders.vue